import { render, staticRenderFns } from "./BmsPanel.vue?vue&type=template&id=50b5ca16&"
import script from "./BmsPanel.vue?vue&type=script&lang=js&"
export * from "./BmsPanel.vue?vue&type=script&lang=js&"
import style0 from "./BmsPanel.vue?vue&type=style&index=0&id=50b5ca16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports